export const SEARCH_RECORDS_CHUNK_LIMIT = 30;

export const INITIAL_GRID_WIDTH_WITHOUT_PANEL = 1100;
